import React, { useState } from 'react';
import { Checkbox, Tooltip } from 'antd';
import { InfoCircleFilled, FilterFilled } from '@ant-design/icons';
import { setPriorToConsentFilterList } from '../../../actions/diagnose_vendor_trace_actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const CheckboxGroup = Checkbox.Group;

const VendorTracePriorToConsentFilter = ({ setPriorToConsentFilterList, priorToConsentFilterList, consentTypeName }) => {
    const [checkedList, setCheckedList] = useState(priorToConsentFilterList);

    const plainOptions = [
        { label: `Post ${consentTypeName}`, value: false },
        { label: `Prior to ${consentTypeName}`, value: true },
    ];

    const onChange = (list) => {
        setPriorToConsentFilterList(list);
        setCheckedList(list);
    };

    return (
        <div className={'vendor-trace-prior-to-consent-filter-container'}>
            <div className={'vendor-trace-prevalence-filter-title-row'}>
                <FilterFilled />
                <div>User Preference Status</div>
                <Tooltip
                    placement="topRight"
                    overlayClassName="vendor-trace-prior-to-consent-filter-tooltip-overlay"
                    title={() => {
                        return (
                            <div className={'vendor-trace-prior-to-consent-filter-tooltip-content'}>
                                <div>When we scan your website we emulate a real user coming to
                                    your website in a specific workflow such as choosing their
                                    privacy preferences on the consent banner. This filter
                                    allows your to see which vendors were triggered prior to
                                    and post the user saving their preferences.</div>
                            </div>
                        ); 
}
                    }
                >
                    <InfoCircleFilled />
                </Tooltip>
            </div>
            <div className={'vendor-trace-prevalence-filter-block'}>
                <div className={'vendor-trace-prevalence-filter-checkbox-list'}>
                    <CheckboxGroup options={plainOptions} value={checkedList} onChange={onChange} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = function (store) {
    return {
        priorToConsentFilterList: store.diagnoseVendorTraceState.getIn(['priorToConsentFilterList', 'value']),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setPriorToConsentFilterList,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorTracePriorToConsentFilter);
